var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',{staticClass:"text-center display-2 font-weight mt-8 mb-6"},[_vm._v("I miei pagamenti")]),(_vm.payments)?_c('div',_vm._l((_vm.payments),function(p){return _c('payment-list-item',{key:p.id,attrs:{"payment":p}})}),1):_c('div',_vm._l((3),function(n){return _c('v-skeleton-loader',{key:n,attrs:{"type":"table-heading"}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }